<template>
    <b-container fluid style="padding-bottom:135px; padding-top:0" class="bg_atos">
        <div class="container wrapper-listActs">
            <md-dialog :md-active.sync="showDialogKeywordsAlerts" class="dialog_theme_kwAlert">
                <keywordsAlertList
                    class="wrapper-dialog" 
                    v-if="showDialogKeywordsAlerts"
                    v-on:showDialogKeywordsAlerts="showDialogKeywordsAlerts = false" 
                >
                </keywordsAlertList>
            </md-dialog>
                
            <b-row class="mb-3" align-v="center" v-if="showTypeAdvancedSearch" style="min-height:20px; margin-bottom:0 !important;">
                <b-col cols="12" style="padding-left: 30px;">
                    <span style="color:#666666"> {{selectedTypeAdvancedSearch}}</span>
                </b-col>
            </b-row>
           
          <b-row class="mb-2 " align-v="center">
                <b-col cols="8" sm="2" md="9" lg="9">
                    <div class="field-rouded">
                        <b-input-group>                                                   
                            <b-form-input
                                id="input-1"
                                v-model="searchedWords"
                                required
                                :placeholder="`${$t('placeholder_search')}`" 
                                v-on:keyup.enter="doNewSearch"
                                v-b-tooltip.hover 
                                title="Insira na busca o número do ato normativo - decreto, portaria ou instrução normativa - ou a palavra-chave - termo, expressão ou frase - que gostaria de buscar. Por exemplo: meio ambiente, direitos humanos, sociedade civil, segurança pública, exoneração, nomeação, etc."
                            ></b-form-input>     
                            
                            <div class="advancedSearch" v-if="showAdvancedSearch" :class="borderTopDiv ? 'borderTopDiv' : ''">
                                <div style="display: flex; gap: 10px; margin-bottom: 20px; ">
                                    <div style="margin-bottom:10px">Tipo de Busca:</div>
                                    <div>
                                        <div v-for="(val, key) in typeAdvancedSearch" :key="key" class="radioAdvancedSearch">
                                            <input type="radio" :value="val.value"  v-model="selectedAdvancedSearch" :id="val.value" @click="uncheckRadios(val) ;">
                                            <label :for="val.value">{{ val.text }}</label>
                                        </div>
                                    </div>
                                </div>
                                <div style="margin-top: 15px; padding: 10px 0; display: flex; gap: 5px;">
                                    <div>Exemplos de palavras-chave:</div>
                                    <div style="display: flex; gap: 3px;">
                                        <div
                                            v-for="(word, index) in keywordsExample"
                                            :key="word"
                                            @click="searchWord(word)"
                                        >
                                            <span style="cursor: pointer; text-decoration: underline">{{ word }}</span>{{ (index > keywordsExample.length - 1) ? '' : ',' }}
                                        </div>
                                    </div>
                                </div>

                                <!-- <div style="margin-bottom:10px">Tipo de Busca:</div>
                                <div v-for="(val, key) in typeAdvancedSearch" :key="key" class="radioAdvancedSearch">
                                    <input type="radio" :value="val.value"  v-model="selectedAdvancedSearch" :id="val.value" @click="uncheckRadios(val) ;">
                                    <label :for="val.value">{{ val.text }}</label>
                                </div> -->
                                

                                <!-- <hr> -->
                                    <!-- Exceto estas palavras:
                                    <b-form-input v-model="exceptWord" style="width:445px"></b-form-input>    
                                -->

                                <!-- <div style="display: grid; justify-content: end; margin-bottom:8px">
                                    <b-icon icon="search" scale="1.5" variant="grey" @click="doNewAdvancedSearch" class="styleLupa"  v-b-tooltip.hover title="Buscar"></b-icon>
                                </div>                   -->

                            </div> 
                        </b-input-group>
                    </div>
                
                </b-col>
                <b-col cols="4" md="3" lg="3" style="padding-left:0">
                    <b-input-group-text class="icon-rouded">
                        <b-icon v-if="user.loggedIn" icon="star-fill" scale="0.9" class="styleStar" v-b-modal.modal-multi-3  v-b-tooltip.hover title="Salvar Palavras-chave" @click="showDialogKeywordsAlertsMethod()"></b-icon>
                        <div class="advancedSearchLink" v-on:click="showAdvancedSearchMethod()"> Busca Avançada </div>
                        <div class="btn-lupa">
                            <b-icon  icon="search" variant="grey" @click="doNewSearch" class="styleLupa" v-b-tooltip.hover title="Buscar"></b-icon>   
                        </div>
                    </b-input-group-text>
                    
                </b-col>
            </b-row>

            <b-row class="mb-4">
                <b-col  cols="12" sm="12" md="3" lg="3">
                    <date-picker v-b-tooltip.hover title="Dados disponíveis a partir de 2007"  v-model="selectedInitialDate" placeholder="Selecione a data inicial" format="DD/MM/YYYY" valueType="YYYY-MM-DD">
                        <template slot="icon-calendar">
                            <b-icon stacked icon="calendar" scale="1.5"  variant="dark" ></b-icon>                                
                        </template>                              
                    </date-picker>
                </b-col>
                <b-col cols="12" sm="12" md="3" lg="3">
                    <date-picker  v-model="selectedEndDate" placeholder="Selecione a data final" format="DD/MM/YYYY" valueType="YYYY-MM-DD">
                        <template slot="icon-calendar">
                            <b-icon stacked icon="calendar" scale="1.5"  variant="dark" ></b-icon>                                
                        </template>                              
                    </date-picker>
                </b-col>
                <b-col cols="12" sm="12" md="3" lg="3">
                    <md-field>
                        <label>Tipo de Modificação</label>
                        <md-select class="selectAto" v-model="selectedActTypeModification" multiple>
                            <md-option value="2" class="dot dotAddedLi"   >Incluiu texto em outro decreto</md-option>
                            <md-option value="1" class="dot dotChangedLi" >Alterou texto em outro decreto</md-option>
                            <md-option value="3" class="dot dotRemovedLi" >Revogou texto em outro decreto</md-option>
                            <md-option value="0" class="dot dotDisableLi" >Não modificou texto em outro decreto</md-option>
                        </md-select>
                    </md-field>
                </b-col>
                <b-col cols="12" sm="12" md="3" lg="3">
                    <md-field>
                        <label>Ministério</label>
                        <md-select class="selectAto" v-model="selectedMinistry" multiple>
                            <md-option value="agricultura">Ministério da Agricultura</md-option>
                            <md-option value="cidadania">Ministério da Cidadania</md-option>
                            <md-option value="ciência">Ministério da Ciência, Tecnologia e Inovações</md-option>
                            <md-option value="cidades">Ministério das Cidades</md-option>
                            <md-option value="comunicações">Ministério das Comunicações</md-option>
                            <md-option value="cultura">Ministério da Cultura</md-option>
                            <md-option value="desenvolvimento regional">Ministério do Desenvolvimento Regional</md-option>
                            <md-option value="defesa">Ministério da Defesa</md-option>
                            <md-option value="economia">Ministério da Economia</md-option>
                            <md-option value="educação">Ministério da Educação</md-option>
                            <md-option value="fazendo">Ministério da Fazenda</md-option>
                            <md-option value="indústria">Ministério da Indústria, Comércio Exterior e Serviços</md-option>
                            <md-option value="infraestrutura">Ministério da Infraestrutura</md-option>
                            <md-option value="justiça">Ministério da Justiça e Segurança Pública</md-option>
                            <md-option value="meio ambiente">Ministério do Meio Ambiente</md-option>
                            <md-option value="direitos humanos">Ministério da Mulher, da Família e dos Direitos Humanos</md-option>
                            <md-option value="saúde">Ministério da Saúde</md-option>
                            <md-option value="segurança">Ministério da Segurança Pública</md-option>
                            <md-option value="transparência">Ministério da Transparência e Controladoria-Geral da União</md-option>
                            <md-option value="trabalho">Ministério do Trabalho</md-option>
                            <md-option value="turismo">Ministério do Turismo</md-option>
                            <md-option value="transportes">Ministério dos Transportes, Portos e Aviação Civil</md-option>
                            <md-option value="união">Ministério da Público da União</md-option>
                        </md-select>
                    </md-field>
                </b-col>
            </b-row> 

            <b-row class="mb-4">
                <b-col  cols="12" sm="12" md="12" lg="12">
                    <div style="display: flex; align-items: center; justify-content: space-between;">
                        <div class="act-options">                        
                            <md-checkbox 
                                v-model="types" 
                                v-for="(option, index) in typesOptions" 
                                :value="option.value"
                                :key="index"
                                @change="() => setTypeOptions()"
                                class="md-primary"
                            >
                                <div v-b-tooltip.hover.top="option.tooltip">
                                    {{option.text}}
                                </div>
                            </md-checkbox>
                            
                        </div>
                        <div style="display: flex; gap: 10px; cursor: pointer" @click="goToPanel">
                            <div style="position: relative; width: 55px; height: 50px;">
                                <img src="../assets/panel.png" alt="analytics_panel" width="100%" height="100%" />
                            </div>
                            <div style="display: flex; max-width: 300px; align-items: center">
                                Analise os decretos, portarias e instruções normativas através de gráficos
                            </div>
                        </div>
                    </div>
                    
                </b-col>
            </b-row>

            <b-tabs content-class="mt-3" active-nav-item-class="tabActive" v-model="tabIndex">
                <b-tab title="Resultados" :title-link-class="'tabAtos'" >
                    <template #title>
                        <div v-b-tooltip.hover.top="'Resultados da sua busca em ordem cronológica'">Atos Normativos</div>
                    </template>
                    <template v-if="!loadingAct && !hasErro">
                        <div class="elemHeaderTab">
                            <div style="padding-left:15px; color:#666; align-self: center;"> 
                                <template v-if="rows > 0">
                                    <div><strong>{{ rows }}</strong> {{$t('result_search')}}<template v-if="rows>1 || rows == 0">{{$t('result_search_plural')}}.</template></div>
                                </template>
                                <template v-if="searchedWordsAux">
                                    <div>{{$t('result_search2')}}<span class="textResultSearch">{{searchedWordsAux}}</span></div>
                                </template>
                                <template v-if="showPeriod">
                                    <div>{{stringPeriod}}</div>
                                </template>        
                            </div>
                            <div style="align-self: center;"> 
                                <b-pagination v-if="listActs.length>0" class="mb-0"
                                        :total-rows="rows" 
                                        v-model="currentPage" 
                                        :per-page="perPage"  
                                        first-number  
                                        last-number  
                                        align="right" 
                                        >
                                </b-pagination>
                            </div>
                        </div>
                        
                        <div v-for="(item, index) in listActs" v-bind:key="index">
                            <md-card class="cardList">
                                <md-card-content>
                                    <b-row  @click="rowClickHandler(item.type, item.number)">

                                        <!-- <b-col lg="2">
                                            <b-row>
                                                <b-col cols="6" sm="2" md="3" lg="12" class="titleCell">Tipo:</b-col>
                                                <b-col cols="6" sm="2" md="6" lg="12" class="">{{item.type}}</b-col>
                                            </b-row>
                                        </b-col> -->

                                        <b-col lg="2" style="padding-right:0">
                                            <b-row>
                                                <b-col cols="6" sm="2" md="3" lg="12" class="titleCell">{{$t('act')}}:</b-col>
                                                <b-col cols="6" sm="2" md="6" lg="12" class="">{{item.title}}</b-col>
                                            </b-row>
                                        </b-col>
                                        <b-col lg="2" style="padding-right:0;padding-left:0">
                                            <b-row>
                                                <b-col cols="6" sm="2" md="3" lg="12" class="titleCell">{{$t('publicationDate')}}:</b-col>
                                                <b-col cols="6" sm="2" md="6" lg="12" class="">{{item.publication_date | formatDateString}}</b-col>
                                            </b-row>
                                        </b-col>
                                        <b-col lg="6" style="padding-left:0">
                                            <p class="titleCell">{{$t('shortdescriptionAct')}}:</p>
                                            <p class="descriptionList">
                                                {{item.description ? item.description : '--'}}
                                            </p>
                                        </b-col>
                                        <b-col class="grid-dots justify-content-md-center  text-center" lg="2" v-if="item.status">

                                            <b-row class="justify-content-md-center text-center" >
                                                <b-col cols="4" sm="2" md="3" lg="12" class="elem-dots">
                                                    <span class="dot" v-bind:class="item.status.added ? 'dotAdded' : 'dotDisable'"></span>
                                                    <span v-bind:class="item.status.added ? 'textDot' :'textDotDisable' ">Incluiu</span>
                                                </b-col>
                                                <b-col cols="4" sm="2" md="3" lg="12" class="elem-dots">
                                                    <span class="dot" v-bind:class="item.status.changed ? 'dotChanged' : 'dotDisable'"></span>
                                                    <span v-bind:class="item.status.changed ? 'textDot' :'textDotDisable' ">Alterou</span> 
                                                </b-col>
                                                <b-col cols="4" sm="2" md="3" lg="12" class="elem-dots">
                                                    <span class="dot" v-bind:class="item.status.removed ? 'dotRemoved' : 'dotDisable'"></span>
                                                    <span v-bind:class="item.status.removed ? 'textDot' :'textDotDisable' ">Revogou</span>    
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                    </b-row>
                                </md-card-content>
                            </md-card>
                        </div>

                        <b-pagination  v-if="listActs.length>0" :total-rows="rows" v-model="currentPage" :per-page="perPage" first-number  last-number  align="right"></b-pagination>
                        
                        <div v-if="msgInfo!=''"  class="msgInfo" >{{msgInfo}}</div>

                         <b-row>
                            <b-col>
                                <div style="text-align: left; font-size:11px; font-weight:600;">* Apenas decretos possuem modificações </div>
                            </b-col>
                        </b-row>
                    </template>

                    <div v-if="loadingAct" class="loadingData">
                        <strong>Carregando...</strong>
                        <b-spinner style="color:#1937a0" small></b-spinner>
                    </div>

                    <div v-if="!loadingAct && hasErro" class="loadingData">
                        {{erroMsg}} 
                    </div>
                </b-tab>

                <b-tab 
                    title="Painel" 
                    :title-link-class="'tabAtos'" 
                >
                    <template #title>
                        <div v-b-tooltip.hover.top="'Analise as instruções normativas, decretos e portarias através de gráficos'">Painel de Análise</div>
                    </template>
                    <div class="elemHeaderTab">
                        <div style="padding-left:15px; color:#666; align-self: center;"> 
                            <template v-if="rows > 0">
                                <strong>{{ rows }}</strong> {{$t('result_search')}}<template v-if="rows>1 || rows == 0">{{$t('result_search_plural')}}.</template>
                                <br>
                            </template>
                            <template v-if="searchedWordsAux">
                                
                                <div>{{$t('result_search2')}}<span class="textResultSearch">{{searchedWordsAux}}</span></div>
                            </template>
                            <template v-if="showPeriod">
                                <div>{{stringPeriod}}</div>
                            </template>        
                        </div>
                        <div style="min-height:35px"></div>
                    </div>
                        
                    <div v-if="msgInfo!=''" class="msgInfo"> {{msgInfo}} </div>
                
                    <template v-else>                
                        <b-container >
                            <b-row>
                                        <b-col class="filter">
                                            <b-dropdown :text="textButtonYears" class="dropdownSelectAnalytics">
                                                <b-form-group>
                                                    <template v-slot:label>
                                                        <b-form-checkbox
                                                        v-model="allYearsSelected"
                                                        @change="toggleAllYears">
                                                        Todos
                                                        </b-form-checkbox>
                                                    </template>

                                                    <b-form-checkbox-group
                                                        v-model="selectedYearsAnalytics"
                                                        :options="years"
                                                        @input="selectYear()"
                                                    ></b-form-checkbox-group>
                                                </b-form-group>                                        
                                            </b-dropdown>
                                            <b-dropdown :text="textButtonMonths" class="dropdownSelectAnalytics">
                                                <b-form-group>
                                                    <template v-slot:label>
                                                        <b-form-checkbox
                                                        v-model="allMonthsSelected"
                                                        @change="toggleAllMonths"
                                                        :disabled="allMonthsDisabled"
                                                        >
                                                        Todos
                                                        </b-form-checkbox>
                                                    </template>

                                                    <b-form-checkbox-group
                                                        v-model="selectedMonthsAnalytics"
                                                        :options="months"
                                                        @input="selectMonth()"
                                                    ></b-form-checkbox-group>
                                                </b-form-group>                                        
                                            </b-dropdown>
                                        
                                        </b-col>
                                    </b-row>
                            <div class="painel-content" v-if="types.includes('decreto')">
                                <b-col class="first-col" md="4" sm="12">
                                    <div v-if="loadingChartPie" style="width: 100%; display: flex; gap: 10px; direction: flex-column; align-items: center; justify-content: center; justify-items: center; margin-top: 200px;">
                                        <strong style="color: #1937a0">Carregando...</strong>
                                        <b-spinner style="color:#1937a0" small></b-spinner>
                                    </div>
                                    
                                    <b-col v-if="!loadingChartPie" cols="12" class="pl-0 pr-0" >
                                    
                                        <b-row :style="{ marginTop: !types.includes('decreto') ? '180px' : '0'}">
                                            <b-col>
                                                <div style="text-align: center; font-size:11px; font-weight:600;">TOTAL DE DECRETOS</div>
                                                <br>
                                                <div style="text-align: center; font-size: 64px; font-weight: 800; font-family: arial; color: rgb(0, 0, 0); letter-spacing: -2px;">{{chartData["decreto_total"]}}</div>
                                            </b-col>
                                        </b-row>
                                        <b-row class="mt-5" v-if="types.includes('decreto')">
                                            <b-col style="height: 100%;">
                                                <div style="text-align: center; font-size:11px; font-weight:600;">TIPOS DE MODIFICAÇÕES</div>
                                                <pieChart
                                                    v-bind:chartPieCategories="chartPieCategories" 
                                                    v-bind:dataArray="chartPieDataArray"
                                                    v-bind:height="chartPieHeight"
                                                    v-bind:total="rows"
                                                ></pieChart> 
                                            </b-col>
                                        </b-row>
                                    
                                        <!-- <b-row>
                                            <b-col>
                                                <div style="text-align: center; font-size:11px; font-weight:600;">* Apenas decretos computados </div>
                                            </b-col>
                                        </b-row> -->
                                    </b-col>
                                    
                                </b-col>

                                <b-col lg="8" md="8" sm="12">
                                    <div v-if="!loadingAct && hasErro" class="loadingData">
                                        {{erroMsg}}
                                    </div>
                                    
                                    <b-row style="height: 100%;">
                                        <b-col class="pr-0 pl-0">
                                            <div v-if="loadingChart" class="loadingData" style="padding-top:50px">
                                                <strong>Carregando...</strong>
                                                <b-spinner style="color:#1937a0" small></b-spinner>
                                            </div>
                                            
                                            
                                            <lineBarChart v-if="!loadingChart"
                                                v-bind:key="'decreto'+chartData.key"
                                                v-bind:title="'DECRETOS'"
                                                v-bind:dataArray="chartData['decreto_values']"
                                                v-bind:categories="chartData['decreto_years']"
                                                v-bind:height="chartAnalyticsYearHeight"
                                                v-bind:serieName="'Quantidade'"
                                                v-bind:chartData="chartData"
                                                v-bind:typeChart="chartAnalyticsType"
                                                v-bind:types="types"
                                            >
                                            </lineBarChart>

                                          
                                        </b-col>

                                      
                                    </b-row>

                                    
                                </b-col>
                            </div>


                            <div class="painel-content" v-if="types.includes('portaria')">
                                <b-col class="first-col" md="4" sm="12">
                                    <div v-if="loadingChart" style="width: 100%; display: flex; gap: 10px; direction: flex-column; align-items: center; justify-content: center; justify-items: center; margin-top: 200px;">
                                        <strong style="color: #1937a0">Carregando...</strong>
                                        <b-spinner style="color:#1937a0" small></b-spinner>
                                    </div>
                                    
                                    <b-col v-if="!loadingChart" cols="12" class="pl-0 pr-0" >
                                    
                                        <b-row :style="{ marginTop: !types.includes('decreto') ? '180px' : '0'}">
                                            <b-col>
                                                <div style="text-align: center; font-size:11px; font-weight:600;">TOTAL DE PORTARIAS</div>
                                                <br>
                                                <div style="text-align: center; font-size: 64px; font-weight: 800; font-family: arial; color: rgb(0, 0, 0); letter-spacing: -2px;">{{chartData['portaria_total']}}</div>
                                            </b-col>
                                        </b-row>
                                    
                                    
                                        <!-- <b-row>
                                            <b-col>
                                                <div style="text-align: center; font-size:11px; font-weight:600;">* Apenas decretos computados </div>
                                            </b-col>
                                        </b-row> -->
                                    </b-col>
                                    
                                </b-col>

                                <b-col lg="8" md="8" sm="12">
                                    <div v-if="!loadingAct && hasErro" class="loadingData">
                                        {{erroMsg}}
                                    </div>
                                   
                                    <b-row style="height: 100%;">
                                        <b-col class="pr-0 pl-0">
                                            <div v-if="loadingChart" class="loadingData" style="padding-top:50px">
                                                <strong>Carregando...</strong>
                                                <b-spinner style="color:#1937a0" small></b-spinner>
                                            </div>
                                            
                                            
                                            <lineBarChart v-if="!loadingChart"
                                                v-bind:key="'portaria'+chartData.key"
                                                v-bind:title="'PORTARIAS'"
                                                v-bind:dataArray="chartData['portaria_values']"
                                                v-bind:categories="chartData['portaria_years']"
                                                v-bind:height="chartAnalyticsYearHeight"
                                                v-bind:serieName="'Quantidade'"
                                                v-bind:chartData="chartData"
                                                v-bind:typeChart="chartAnalyticsType"
                                                v-bind:types="types"
                                            >
                                            </lineBarChart>

                                          
                                        </b-col>

                                      
                                    </b-row>

                                    
                                </b-col>
                            </div>



                             <div class="painel-content" v-if="types.includes('instrucao-normativa')">
                                <b-col class="first-col" md="4" sm="12">
                                    <div v-if="loadingChart" style="width: 100%; display: flex; gap: 10px; direction: flex-column; align-items: center; justify-content: center; justify-items: center; margin-top: 200px;">
                                        <strong style="color: #1937a0">Carregando...</strong>
                                        <b-spinner style="color:#1937a0" small></b-spinner>
                                    </div>
                                    
                                    <b-col v-if="!loadingChart" cols="12" class="pl-0 pr-0" >
                                    
                                        <b-row :style="{ marginTop: !types.includes('decreto') ? '180px' : '0'}">
                                            <b-col>
                                                <div style="text-align: center; font-size:11px; font-weight:600;">TOTAL DE INSTRUÇÕES NORMATIVAS</div>
                                                <br>
                                                <div style="text-align: center; font-size: 64px; font-weight: 800; font-family: arial; color: rgb(0, 0, 0); letter-spacing: -2px;">{{chartData['instrucao-normativa_total']}}</div>
                                            </b-col>
                                        </b-row>
                                    
                                    
                                        <!-- <b-row>
                                            <b-col>
                                                <div style="text-align: center; font-size:11px; font-weight:600;">* Apenas decretos computados </div>
                                            </b-col>
                                        </b-row> -->
                                    </b-col>
                                    
                                </b-col>

                                <b-col lg="8" md="8" sm="12">
                                    <div v-if="!loadingAct && hasErro" class="loadingData">
                                        {{erroMsg}}
                                    </div>
                                   
                                    <b-row style="height: 100%;">
                                        <b-col class="pr-0 pl-0">
                                            <div v-if="loadingChart" class="loadingData" style="padding-top:50px">
                                                <strong>Carregando...</strong>
                                                <b-spinner style="color:#1937a0" small></b-spinner>
                                            </div>
                                            
                                            
                                            <lineBarChart v-if="!loadingChart"
                                                v-bind:key="'portaria'+chartData.key"
                                                v-bind:title="'INSTRUÇÕES NORMATIVAS'"
                                                v-bind:dataArray="chartData['instrucao-normativa_values']"
                                                v-bind:categories="chartData['instrucao-normativa_years']"
                                                v-bind:height="chartAnalyticsYearHeight"
                                                v-bind:serieName="'Quantidade'"
                                                v-bind:chartData="chartData"
                                                v-bind:typeChart="chartAnalyticsType"
                                                v-bind:types="types"
                                            >
                                            </lineBarChart>

                                          
                                        </b-col>

                                      
                                    </b-row>

                                    
                                </b-col>
                            </div>
                        </b-container>
                    </template>
                </b-tab> 
            </b-tabs>
        </div>
    </b-container>
</template>

<script>
    import firebase from '@/firebaseInit.js';
    import i18n from '@/i18n.js'
    import { mapGetters } from "vuex";
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import 'vue2-datepicker/locale/pt-br';
    import {parse, format, isValid} from 'date-fns'
    import moment from 'moment'
    import keywordsAlertList from '@/components/keywordsAlert/keywordsAlertList.vue'
    import lineBarChart from '@/components/charts/lineBarChart.vue'
    import pieChart from '@/components/charts/pieChart.vue'
    import {APIService} from '@/apiService';

    const apiService = new APIService();
    

export default {
    
    components: { 
        DatePicker, 
        keywordsAlertList,
        lineBarChart,
        pieChart
    },

    mounted(){        
        // if (this.user.loggedIn) {
        //     console.log(this.user)
        //     this.refUsers.doc(this.user.data.id).collection("keywordsAlerts").get().then(querySnapshot => {
        //         querySnapshot.forEach(doc => {
        //             if(doc){
        //                 let item = {   
        //                     id: doc.id,
        //                     name : doc.data().name,
        //                     keywords: doc.data().keywords, 
        //                     alert: doc.data().alert,
        //                     selectedAdvancedSearch: doc.data().advancedSearch,
        //                 }

        //                 console.log(item);
        //                 // if(doc.data().advancedSearch){
        //                 //     item.selectedAdvancedSearchString = this.mountStringSelectedAdvancedSearch(doc.data().advancedSearch)
        //                 // }

        //                 // this.$store.commit('addkeywordsAlerts', item)
        //             }
        //         });
        //     }).catch( error => {console.log("erro:" + error)});   
        // }

        this.mountYears();     
        this.filterParamAnalytics.period_type = "year";
        this.search(); 
    },

    data() {
      return {
            //refUsers: firebase.firestore().collection('users'),
            keywordsExample: ["meio ambiente", "direitos humanos", "sociedade civil", "segurança pública", "exoneração"],

            hasErro :false,
            erroMsg : i18n.t('noData'),
            msgInfo : '',
            showDialogKeywordsAlerts : false,
                  
            perPage: 20,
            rows:0,
            decretosCount: 0,

            filterParams :  {},

            searchedWordsAux:'',

            loadingChartPie: false,
            loadingAct : null,

            tabIndex : 0,

            showPeriod : false,
            stringPeriod:'',

            filterParamAnalytics:{},
            chartData: {},

            allMonthsDisabled : false,
            years : [],
            months:[
                {value:1 ,  text: "Janeiro"  },
                {value:2 ,  text: "Fevereiro"},
                {value:3 ,  text: "Março"    },
                {value:4 ,  text: "Abril"    },
                {value:5 ,  text: "Maio"     },
                {value:6 ,  text: "Junho"    },
                {value:7 ,  text: "Julho"    },
                {value:8 ,  text: "Agosto"   },
                {value:9 ,  text: "Setembro" },
                {value:10,  text: "Outubro"  },
                {value:11,  text: "Novembro" },
                {value:12,  text: "Dezembro" },
            ],

            types: ["decreto", "portaria", "instrucao-normativa"],
            typesOptions: [
                { text: 'Decretos', value: 'decreto', tooltip: 'Decretos do Executivo - atos administrativos que regulamentam as leis, não podendo contrariá-las ou modificá-las, e dispõem sobre a organização da administração pública.' },
                { text: 'Portarias', value: 'portaria', tooltip: 'Atos editados com o objetivo de instruir sobre assuntos de natureza predominantemente administrativa, especialmente os relativos à gestão de pessoas (administração, exoneração, designação, delegação de competência, punição, etc.), tratar da organização e do funcionamento dos serviços da repartição, e orientar os servidores na aplicação de textos legais, além de disciplinar matéria não regulada em lei.' },
                { text: 'Instruções Normativas', value: 'instrucao-normativa', tooltip: 'Atos administrativos que visam disciplinar a execução de determinada atividade a ser desempenhada pelo Poder Público. Buscam detalhar com maior precisão o conteúdo de determinada lei, sem criar novos direitos ou obrigações, apenas explicando de forma mais clara o que já está previsto na legislação.' },
            ],

            textButtonYears:"Ano",
            allYearsSelected: false,
            selectedYearsAnalytics: [],

            textButtonMonths:"Mês",
            allMonthsSelected: false,
            selectedMonthsAnalytics: [],            

            keyChartAnalytics :0,
            chartArrayAnalyticsYear:[],
            chartAnalyticsYearCategories:[],
            chartAnalyticsYearHeight : "400px",
            chartAnalyticsType:'',
            loadingChart:false,
            
        
            keyChartPie:0,
            chartPieDataArray: [10,10,10,10],
            chartPieCategories:[],
            chartPieHeight:"400",  
               
            showAdvancedSearch:false,

            borderTopDiv:false,

            typeAdvancedSearch:[
                { text: 'Todas as Palavras (Padrão)'    , value: 1},
                { text: 'Qualquer uma das palavras'     , value: 2},
                { text: 'Frase exata'                   , value: 3},
                // { text: 'Inicia com'                , value: 4 },
            ]
           
      }
    },

    computed: {
        currentPage:{
            get(){ return this.$store.getters.currentPage},
            set(value){
               this.$store.commit('setCurrentPage',value);
               this.fetchData();
            },
        },

        ...mapGetters({
            user: "user",            
        }),        

        searchedWords: {
            get () {
                return this.$store.state.searchedWords
            },
            set (value) {
                this.$store.commit('setSearchedWords', value)
            }
        }, 

        selectedMinistry:{
            get () {
                return this.$store.state.selectedMinistry;
            },
            set (value) {
                this.$store.commit('setSelectedMinistry', value)                
            }
        },

        selectedActTypeModification:{
            get () {
                return this.$store.state.selectedActTypeModification;
            },
            set (value) {
                this.$store.commit('setSelectedActTypeModification', value)                
            }
        },

        showTypeAdvancedSearch:{
            get () {
                return this.$store.state.showTypeAdvancedSearch;
            },
            set (value) {
                this.$store.commit('setShowTypeAdvancedSearch', value)
            }
        },

        selectedTypeAdvancedSearch:{
            get () {
                return this.$store.state.selectedTypeAdvancedSearch;
            },
            set (value) {
                this.$store.commit('setSelectedTypeAdvancedSearch', value)
            }
        },

        selectedAdvancedSearch:{
            get () {
                return this.$store.state.selectedAdvancedSearch;
            },
            set (value) {
                this.$store.commit('setSelectedAdvancedSearch', value)
            }
        },        
    
        listActs:{
            get(){return this.$store.state.dataList},
            set(value){this.$store.commit('setDataList', value)}
        },

        selectedInitialDate: {
            get () {
                return this.$store.state.selectedInitialDate
            },
            set (value) {
                this.$store.commit('setSelectedInitialDate', value)
            }
        },

        selectedEndDate: {
            get () {
                return this.$store.state.selectedEndDate
            },
            set (value) {
                this.$store.commit('setSelectedEndDate', value)
            }
        },       

    },

    methods: {
        setTypeOptions() {
            // @TODO - adicionar lógica para sempre ter 1 selected 
            this.doNewSearch();
        },
        searchWord(word){ 
            this.searchedWords = word;
        },
        goToPanel() {
            this.tabIndex = 1;
            /* @TODO - não necessário enquanto só tiver 2 tabs
                    1. pegar lista tabs
                    2. mapear e achar index da tab panel
                    3. this.tabIndex = panelIndex
            */
        },

        uncheckRadios: function (val) {
            this.selectedAdvancedSearch = "";
        },
     
        rowClickHandler(actType , actNumber) {
            this.$router.push("/detailActs/" + actType  +'/'+ actNumber);
        },

        showDialogKeywordsAlertsMethod(){
            
            if(this.user.loggedIn){
                if(this.$store.state.privacyPolicyOk){
                    if(this.searchedWords !=''){
                        this.showDialogKeywordsAlerts = true;
                    }else{
                        this.$bvModal.msgBoxOk(i18n.t('msgValidationSearchedKw'), {
                            title: i18n.t('msgTitleWarning'),
                            size: 'sm',
                            buttonSize: 'sm',
                            okVariant: 'warning',
                            headerClass: 'p-2 border-bottom-0',
                            footerClass: 'p-2 border-top-0',
                            centered: true
                        })
                    }
                }else{
                    this.$bvModal.msgBoxOk(i18n.t('infoMsgpolicyPrivacyAgree'), {
                            title: i18n.t('msgTitleWarning'),
                            size: 'sm',
                            buttonSize: 'sm',
                            okVariant: 'warning',
                            headerClass: 'p-2 border-bottom-0',
                            footerClass: 'p-2 border-top-0',
                            centered: true
                    })
                }
                
            }else{
                this.$bvModal.msgBoxOk(i18n.t('msgValidationSaveSearch'), {
                    title: i18n.t('msgTitleWarning'),
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'warning',
                    headerClass: 'p-2 border-bottom-0',
                    footerClass: 'p-2 border-top-0',
                    centered: true
                })
            }
            
        },

        useInSearch(value){
            this.$store.commit('setSearchedWords', value)
            this.showDialogKeywordsAlerts = false;
        },

        validationParams(){
            var paramsStatus = true;

            if(this.$store.getters.searchedWords.length>0 && this.$store.getters.searchedWords.length<=2){
                this.$bvModal.msgBoxOk(i18n.t('msgValidationSearchedKwLength'), {
                    title: i18n.t('msgTitleWarning'),
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'warning',
                    headerClass: 'p-2 border-bottom-0',
                    footerClass: 'p-2 border-top-0',
                    centered: true
                })
                paramsStatus = false;
            }                  
        
            if(paramsStatus){
                if((this.selectedInitialDate && !this.selectedEndDate) || (this.selectedEndDate && !this.selectedInitialDate)){
                    this.$bvModal.msgBoxOk(i18n.t('msgValidationSearchedKwRangeDate'), {
                        title: i18n.t('msgTitleWarning'),
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'warning',
                        headerClass: 'p-2 border-bottom-0',
                        footerClass: 'p-2 border-top-0',
                        centered: true
                    })
                    paramsStatus = false;
                }
            }

            if(paramsStatus){
                if(this.selectedInitialDate > this.selectedEndDate){
                    this.$bvModal.msgBoxOk(i18n.t('msgValidationSearchedKwRangeInitialDateAfterEndDate'), {
                        title: i18n.t('msgTitleWarning'),
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'warning',
                        headerClass: 'p-2 border-bottom-0',
                        footerClass: 'p-2 border-top-0',
                        centered: true
                    })
                    paramsStatus = false;
                }
            }

            if(paramsStatus){
                if(this.selectedInitialDate > this.selectedEndDate){
                    this.$bvModal.msgBoxOk(i18n.t('msgValidationSearchedKwRangeEndDateBeforeInitialDate'), {
                        title: i18n.t('msgTitleWarning'),
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'warning',
                        headerClass: 'p-2 border-bottom-0',
                        footerClass: 'p-2 border-top-0',
                        centered: true
                    })
                    paramsStatus = false;
                }
            }         
           
           if(paramsStatus){
                this.filterParams = {}
               
                if(this.$store.getters.searchedWords.length>0)
                    
                   this.filterParams["search_txt"]  = this.$store.getters.searchedWords;        

                if(this.selectedInitialDate){
                    this.filterParams["start_date"]  = this.selectedInitialDate;
                }

                if(this.selectedEndDate){
                    this.filterParams["end_date"]    = this.selectedEndDate;
                }

                if (this.$store.getters.selectedMinistry.length) {
                    this.filterParams["organs"] = this.$store.getters.selectedMinistry;
                }
            
                if(this.$store.getters.selectedActTypeModification.length>0){
                    this.filterParams["modifieds"] = this.$store.getters.selectedActTypeModification;
                }
                
                if(this.selectedAdvancedSearch==null || this.selectedAdvancedSearch==""){
                    this.filterParams['search_txt_type'] = 2; 
                }else{
                    this.filterParams['search_txt_type'] = this.selectedAdvancedSearch; 
                }
                
                this.filterParams["offset"] = this.currentPage -1 ;
                this.filterParams["limit"]   = this.perPage;

                return paramsStatus;
           }
        },

        periodFormat(){
            if(this.selectedInitialDate){
                let selectedInitialDateAux = new Date(this.selectedInitialDate+'T00:00')              
                let selectedEndDateAux = new Date(this.selectedEndDate+'T00:00')
                this.stringPeriod = "Período: " + selectedInitialDateAux.toLocaleDateString() + " a " + selectedEndDateAux.toLocaleDateString() + ".";
            }
        },

        mountMonthsSelect(){
            let months =[
                {value:1 ,  text: "Janeiro"  , disabled:false},
                {value:2 ,  text: "Fevereiro", disabled:false},
                {value:3 ,  text: "Março"    , disabled:false},
                {value:4 ,  text: "Abril"    , disabled:false},
                {value:5 ,  text: "Maio"     , disabled:false},
                {value:6 ,  text: "Junho"    , disabled:false},
                {value:7 ,  text: "Julho"    , disabled:false},
                {value:8 ,  text: "Agosto"   , disabled:false},
                {value:9 ,  text: "Setembro" , disabled:false},
                {value:10,  text: "Outubro"  , disabled:false},
                {value:11,  text: "Novembro" , disabled:false},
                {value:12,  text: "Dezembro" , disabled:false}
            ]

            this.allMonthsDisabled = false;

            let year1= parseInt(this.selectedInitialDate.split("-")[0]);
            let year2= parseInt(this.selectedEndDate.split("-")[0]);

            let monthAuxs = [];
            
            if(year1 == year2){
                let month1= parseInt(this.selectedInitialDate.split("-")[1]);
                
                for(let i=month1; i<=month1; i++){
                    monthAuxs.push(i);
                }

                this.allMonthsDisabled = true;

            }else{

                let month1= parseInt(this.selectedInitialDate.split("-")[1]);

                monthAuxs = [];
                for(let i=month1; i<=12; i++){
                    monthAuxs.push(i);
                }
               
                let month2= parseInt(this.selectedEndDate.split("-")[1]);
               
                for(var i= 1; i<=month2; i++){
                    monthAuxs.push(i);
                }
                 
            }

           

            for(let month in months){
                if(!monthAuxs.includes(months[month].value))
                    months[month].disabled = true;
            }

            this.months = months;

        },

        async search(){
            //seta busca avancada para vazio caso nao exista termo a ser buscado
            if(this.$store.getters.searchedWords == ''){
                this.selectedAdvancedSearch=1
            }

            //fecha div da busca avancada ao realizar a busca
            if(this.showAdvancedSearch){
                this.showAdvancedSearchMethod();
            }
                
            if(this.selectedAdvancedSearch!=null && this.selectedAdvancedSearch!="" && this.selectedAdvancedSearch!=1){
                this.showTypeAdvancedSearch = true;

                this.selectedTypeAdvancedSearch = this.mountStringSelectedAdvancedSearch(this.selectedAdvancedSearch)
                
            }else{
                this.selectedTypeAdvancedSearch ="";
            }

            this.filterParams["offset"] = this.currentPage -1 ;

            this.mountYears();

            if(this.selectedInitialDate)
                this.mountMonthsSelect();

            this.showPeriod = false;
            this.msgInfo = '';

            if(this.validationParams()){
                try {
                      
                    this.loadingAct = true;
                    this.hasErro = false;
                    
                    this.decretosCount = 0;

                    if (this.types.length) {
                        this.listActs = [];
                        this.rows = 0;

                        this.types.map(async (type) => {
                            this.filterParams["act_type"] = type;
                            
                            await apiService.getListActs(apiService.objectToQuerystring(this.filterParams)).then((data) => {    
                                this.loadingAct = false; 

                                if(!this.isEmpty(data.items)){
                                    this.listActs.push(...data.items);
                                    this.rows += data.metadata.total;
                                    if (type == "decreto") this.decretosCount = data.metadata.total;
                                }
                                // }else{
                                //     this.listActs = [];
                                //     this.rows = 0;
                                //     this.msgInfo = i18n.t('noDataInfo')
                                // }
                                
                            }).catch(error => {
                                this.loadingAct = false;
                                this.listActs = []; 
                                this.rows = 0;
                                this.hasErro = true;
                                this.decretosCount = 0;
                                
                            });    
                        });

                        if (!this.listActs.length) {
                            this.rows = 0;
                            this.msgInfo = i18n.t('noDataInfo')
                        }

                        this.listActs.sort();
                    }
                    
                    this.searchedWordsAux = this.searchedWords;

                    if(this.selectedInitialDate){
                        this.showPeriod = true;
                        this.periodFormat();
                    }
                    //atualiza os graficos
                   
                    this.analyticsInfo();

                }catch(e){
                    console.log('error' + e)
                }
            }

            window.search = this.doNewSearch;
        },

        fetchData() {
            this.hasErro = false;
            this.filterParams["offset"] = this.currentPage -1 ;
            this.filterParams["limit"] = this.perPage;
            this.loadingAct = true;
            
            // apiService.getListActs(apiService.objectToQuerystring(this.filterParams))
            // .then((data) => {    
            //     this.loadingAct = false;
            //     if(data){
            //         this.listActs = data.items;
            //         this.rows = data.metadata.total;
            //     }
            // })   
            // .catch((error) => {
            //     if(error.response){
            //         this.loadingAct = false;
            //         this.hasErro = true;
            //     }
            // })

             if (this.types.length) {
                        this.listActs = [];
                        this.rows = 0;

                        this.types.map(async (type) => {
                            this.filterParams["act_type"] = type;
                            
                            await apiService.getListActs(apiService.objectToQuerystring(this.filterParams)).then((data) => {    
                                this.loadingAct = false; 

                                if(!this.isEmpty(data.items)){
                                    this.listActs.push(...data.items);
                                    this.rows += data.metadata.total;
                                }
                                // }else{
                                //     this.listActs = [];
                                //     this.rows = 0;
                                //     this.msgInfo = i18n.t('noDataInfo')
                                // }
                                
                            }).catch(error => {
                                this.loadingAct = false;
                                this.listActs = []; 
                                this.rows = 0;
                                this.hasErro = true;
                                
                            });    
                        });

                        if (!this.listActs.length) {
                            this.rows = 0;
                            this.msgInfo = i18n.t('noDataInfo')
                        }
                    }
                               
        },

        analyticsInfo(){
            
            if(this.validationParams()){
                try{
                     

                    //apaga o termo buscado anteriormente para adicionar novamente caso seja informado
                    delete this.filterParamAnalytics.search_txt;

                    delete this.filterParamAnalytics.organs;
                    if (this.$store.getters.selectedMinistry) {
                        this.filterParamAnalytics["organs"] = this.$store.getters.selectedMinistry;
                    }
                    
                    if(this.filterParams.search_txt){
                        this.filterParamAnalytics.search_txt = this.filterParams.search_txt
                    }

                    //apaga o termo buscado anteriormente para adicionar novamente caso seja informado
                    delete this.filterParamAnalytics.start_date;
                    delete this.filterParamAnalytics.end_date;

                    if(this.filterParams.start_date){
                        this.filterParamAnalytics.start_date = this.filterParams.start_date
                        this.filterParamAnalytics.end_date   = this.filterParams.end_date

                        if(!this.diffDates >=366){
                            this.filterParamAnalytics.period_type = "month"; 
                        }
                    }

                    delete this.filterParamAnalytics.modifieds;

                    if(this.filterParams.modifieds){
                        this.filterParamAnalytics.modifieds = this.filterParams.modifieds
                    }

                    delete this.filterParamAnalytics.search_txt_type;

                    if(this.filterParams.search_txt_type){
                        this.filterParamAnalytics.search_txt_type = this.filterParams.search_txt_type
                    }
                   
                    this.loadingChart = true;
                    this.msgInfo = '';


                       //chart Pie 

                    this.loadingChartPie = true;

                    apiService.getAnalyticsActTypeModifications(apiService.objectToQuerystring(this.filterParamAnalytics)).then((data) => {    
                        this.loadingChartPie = false;

                        if(!this.isEmpty(data)){
                            var valuesArray = [];
                            Object.keys(data).forEach((key)=> {
                                valuesArray.push(((data[key]/this.rows)*100).toFixed(2));                                
                            });
                            
                            //workaround while cant fix back
                            for (let i = 0; i < valuesArray.length; i++) {
                                const val = Number(valuesArray[i]);
                                if (val > 100) valuesArray[i] = 100 - (Number(valuesArray[0]) + Number(valuesArray[1]) + Number(valuesArray[3]));
                            }                        

                            this.chartPieDataArray = valuesArray
                                                         
                            this.chartPieCategories = Object.keys(data);

                            this.keyChartPie = this.keyChartPie + 1;
                        }else{
                            console.log("vazio")
                            //this.msgInfo = i18n.t('noDataInfo')
                        }   
                    }).catch(error => {
                        this.loadingChart = false;
                        console.log("erro:" + error)
                    });


                    // graph

                    const promises = [];

                    this.types.map(type => {
                        const url = Object.assign({}, this.filterParamAnalytics);
                        url.act_type = type;

                        const promise = new Promise((resolve, reject) => {
                            apiService.getAnalytics(apiService.objectToQuerystring(url)).then((data) => {    
                                //this.loadingChart = false;

                                if (!data) return this.msgInfo = i18n.t('noDataInfo');
                                
                                resolve({ [type]: data });
                                
                            }).catch(error => {
                                //this.loadingChart = false;
                                console.log("erro:" + error)
                                reject();
                            });
                        });
                        
                        promises.push(promise);
                    });

                    const chartData = {
                        total: 0
                    };
                    let yearsData = [];
                    let yearsObj = {};
                    Promise.all(promises).then((response) => {
                        response.map(item => {
                            const [key, data] = Object.entries(item)[0];
                            //this.chart_response[key] = data;
                            
                            const years = Object.keys(data);
                            const values = Object.values(data).reduce((a,b) => a + b, 0);
                            
                            chartData[key] = data;
                            chartData[`${key}_total`] = values;
                            chartData.total = chartData.total + values;
                            chartData[`${key}_years`] = years;
                            chartData[`${key}_values`] = Object.values(data);

                            years.map(y => {
                                if (!yearsData.includes(y)) yearsData.push(y)
                            });
                        });

                        yearsData.sort();
                        yearsData.map(y => yearsObj[y] = 0);

                        Object.keys(chartData).map(type => {
                            if (this.types.includes(type)) {
                                Object.entries(chartData[type]).map((item) => {
                                    const [year, value] = item;
                                    yearsObj[year] = yearsObj[year] + value;
                                })
                            }
                        })

                        chartData.yearsObj = yearsObj;
                        
                        chartData.years = yearsData;
                        chartData.values = Object.values(yearsObj).filter(item => item);


                        this.chartData = chartData;

                        this.loadingChart = false;
                    });



                    

                    

                 
                    // this.filterParamAnalytics.act_type = 'decreto';
                    // apiService.getAnalytics(apiService.objectToQuerystring(this.filterParamAnalytics)).then((data) => {    
                    //     this.loadingChart = false;

                    //     if(!this.isEmpty(data)){
                    //         var valuesArray = [];
                    //         Object.keys(data).forEach(function(key) {
                    //             valuesArray.push(data[key]);                                
                    //         });
                    //         this.chartArrayAnalyticsYear = valuesArray
                                                         
                    //         this.chartAnalyticsYearCategories = Object.keys(data);

                    //         this.keyChartAnalytics = this.keyChartAnalytics + 1;

                    //         console.log(this.chartArrayAnalyticsYear)
                    //         console.log(this.chartAnalyticsYearCategories)
                    //         console.log(this.keyChartAnalytics)
                    //     }else{
                    //         this.msgInfo = i18n.t('noDataInfo')
                    //     }   
                    // }).catch(error => {
                    //     this.loadingChart = false;
                    //     console.log("erro:" + error)
                    // });



                 
                    
                }catch(e){
                    console.log("error:" + e)
                }
            }
        },
       
        isEmpty(obj) {
            return Object.keys(obj).length === 0;
        },

        async doNewSearch(){
            this.$store.commit('setCurrentPage', 1);
            await this.search();
        },

        doNewAdvancedSearch(){
            this.showAdvancedSearch = !this.showAdvancedSearch;
            this.borderTopDiv = !this.borderTopDiv;
            this.doNewSearch();
        },

        showAdvancedSearchMethod(){
            this.showAdvancedSearch = !this.showAdvancedSearch;
            this.borderTopDiv = !this.borderTopDiv;
        },

        diffDates(){
            var data1 = new Date(this.selectedInitialDate);
            var data2 = new Date(this.selectedEndDate);
            return (data2 - data1)/(1000*3600*24);
        },

        mountYears(){
            var yearStart = 2007;
            var yearEnd = 2020;

            this.years = [];

            if(this.selectedInitialDate){
                yearStart = this.selectedInitialDate.split("-")[0]
            }

            if(this.selectedEndDate){
                yearEnd = this.selectedEndDate.split("-")[0]
            }


            for(var i= yearStart; i<=yearEnd; i++){
                this.years.push(i);
            }
            this.years = this.years.reverse();
        },

        selectYear(){
            this.textButtonYears = this.selectedYearsAnalytics.length>0 ? this.selectedYearsAnalytics.toString() : "Ano" ;

            if(this.selectedMonthsAnalytics.length==0){
                this.filterParamAnalytics.period_type = "year";
                this.chartAnalyticsType = 'line';

                if(this.selectedYearsAnalytics.length == 1)
                    this.chartAnalyticsType = 'bar';
            }
            else{
                this.filterParamAnalytics.period_type = "month";
                this.chartAnalyticsType = 'bar';
            }

            
            if(this.selectedYearsAnalytics.length==1 &&  this.selectedMonthsAnalytics.length >1)    
                this.chartAnalyticsType = 'line';

            this.filterParamAnalytics.years = this.selectedYearsAnalytics.toString();
            
            this.analyticsInfo();

           
        },

        getMonthName(){
            var selectedMonths= [];
            for(var index in this.selectedMonthsAnalytics){
               for(var index2 in this.months){
                   if(this.months[index2].value == this.selectedMonthsAnalytics[index]){
                       selectedMonths.push(this.months[index2].text);
                   }
               }
            }
            return selectedMonths.toString();
        },

        selectMonth(){   
            
            this.textButtonMonths =  this.selectedMonthsAnalytics.length>0 ? this.getMonthName() : "Mês" ;

            this.chartAnalyticsType = 'bar';
            this.filterParamAnalytics.period_type = "month";

            if(this.selectedMonthsAnalytics.length==0){
                this.filterParamAnalytics.period_type = "year";
            
                this.chartAnalyticsType = 'line';

                if(this.selectedYearsAnalytics.length == 1)
                    this.chartAnalyticsType = 'bar';
            }

            if(this.selectedYearsAnalytics.length==1 &&  this.selectedMonthsAnalytics.length >1)    
                this.chartAnalyticsType = 'line';
            
                this.filterParamAnalytics.months = this.selectedMonthsAnalytics.toString();
           
            this.analyticsInfo();

        },

        toggleAllYears(checked) {
            this.selectedYearsAnalytics = checked ? this.years.slice() : []
        },

        toggleAllMonths(checked) {
            var arrayMonths =[];
            for(var index in this.months){
                arrayMonths.push(this.months[index].value)
            }
            this.selectedMonthsAnalytics = checked ? arrayMonths : []
        },

        mountStringSelectedAdvancedSearch(option){
            let typeAdvancedSearch = [
                { text: 'Todas as Palavras'         , value: 1 },
                { text: 'Qualquer uma das palavras' , value: 2 },
                { text: 'Frase exata'               , value: 3 },
                { text: 'Inicia com'                , value: 4 }
            ]

            let resultString = "Busca Avançada por: ''" + typeAdvancedSearch.filter(function(obj, index){return obj.value===option;})[0].text + "''";

            return resultString;
        }

    },
    watch: {
        selectedYearsAnalytics(newVal, oldVal) {
        // Handle changes in individual flavour checkboxes
        if (newVal.length === 0) {
          this.allYearsSelected = false
        } else if (newVal.length === this.years.length) {
          this.allYearsSelected = true
        } else {
          this.allYearsSelected = false
        }
      },

        selectedMonthsAnalytics(newVal, oldVal) {
            // Handle changes in individual flavour checkboxes
            if (newVal.length === 0) {
            this.allMonthsSelected = false
            } else if (newVal.length === this.months.length) {
            this.allMonthsSelected = true
            } else {
            this.allMonthsSelected = false
            }
        },

        selectedActTypeModification(){
            this.doNewSearch();
        }

    },

    filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        },

        formatDateString: function(value){
            moment.locale('pt-br');
            return moment(String(value)).format('DD [de] MMMM [de] YYYY');
        },
    },


   
}
</script>

<style scoped lang="scss">

    ::v-deep .nav-link{
        border-top-left-radius: 20px !important;
        border-top-right-radius: 20px !important;
    }

     ::v-deep .tabAtos{
        color:#666 !important;
        background-color: #d2d2d2;
    }

    ::v-deep .tabActive{
        color:#1937a0 !important;
    }

    .wrapper-listActs{
        margin-top: 15px;
        padding-bottom: 25px;
        margin-bottom: 15px;
        
        
        .field-rouded{
            border: 1px solid #ccc !important;
            border-radius: 25px;
            //position: absolute;
            width:97%;
            padding-left: 10px;
            padding-right: 10px;
            z-index: 9;
            background: #fff;
            min-height: 47px;
            padding-top: 3px;
           
            // >input{
            //     border-top-left-radius: 25px;
            //     border-bottom-left-radius: 25px;
            //     border-right: none;
            //     height: 27px;
            //     font-size: 14px;
            // }

            

            .input-group > .form-control{
                border:none;
                background: transparent;
                border-radius: 0;
                padding-left: 5px;
                
                &:focus{
                   
                border:none;
                border-right: none !important;
                -webkit-box-shadow: none !important;
                box-shadow: none !important
                }

                
            }
            .borderTopDiv{
                border-top: 1px solid #d2d2d2 !important;
                display: flex;
                flex-direction: column;
            }

        }

        .advancedSearchLink{
            display:inline;
            margin-right: 10px;
            cursor: pointer;
            font-size: 14px;
            text-decoration: underline;
            color:#9a9a9a;
            &:hover{
                color:#5f5f5f;
                // filter: drop-shadow( 1px 1px 2px rgba(0, 0, 0, .5));
            }
        }

        .advancedSearch{
           
            font-size: 14px;
            color:#666;
            width: 100%;            
            padding: 10px 10px 10px 5px;
            

        }

        .icon-rouded{
            border:none;
            background: transparent;
            padding: 0px;
            
            .styleStar{
                margin-right: 10px;
                width: 25px; 
                height: 25px;
                stroke:#ffc700;
                fill:#fff;
                cursor: pointer;
                &:hover{
                    fill:#fff1c0;
                    filter: drop-shadow( 1px 1px 2px rgba(0, 0, 0, .5));
                }
                &:focus{
                    outline: none;
                }
            }
        }     

        .btn-lupa{
            background-color:#1937A0 ;
            border-radius: 40px;
            width: 47px;
            height: 45px;
            display: inline-grid;
            justify-content: center;
            align-content: center;
        }

        .styleLupa{
            fill:#fff;
            width: 35px;
            height: 20px;
            
            cursor:pointer;
            &:hover{
                fill:#b9b9b9; 
                
                filter: drop-shadow( 1px 1px 2px rgba(0, 0, 0, .5));
            }
        }

        .e-ou{
            color: #949393;
            padding-left: 10px;
            margin-bottom: 5px;
        }
            
        .md-card {  border-radius: 20px; }
        
        $break-small: 420px;
        $break-large: 1200px;

        .grid-dots{
           
            align-self: center;
            justify-content: center;
            
           
            @media screen and (max-width: $break-large) {  height: 45px; }
            
        }

        .elem-dots{
            display: flex;
            align-items: center;
            @media screen and (min-width: $break-small) {  justify-content: center; }
            @media screen and (min-width: $break-large) {  justify-content: initial; }
            
        }

        .textDot{
            padding-top: 3px;
        }
        .textDotDisable{
            padding-top: 3px;
            color:#dadada;
        }

        .cardList{
            margin-bottom: 15px;
            min-height: 132px;
            &:hover{
                background-color: #f1f1f1;
                cursor: pointer;
            }
            .md-card-content{
                padding: 15px 15px 5px 15px;
            }
        }

        // .cardListItem{
        //     display: grid;
        //     grid-template-columns: 165px 175px 1fr 140px;

        //     div p {
        //         color:#949393;
        //         margin-bottom: 2px;
        //     }

        //     .descriptionList{
        //         display: -webkit-box; 
        //         -webkit-line-clamp: 3; 
        //         -webkit-box-orient: vertical;
        //         overflow: hidden; 
        //         text-overflow: ellipsis;
        //         min-height: 60px;
        //         color: #000;
        //         text-align: justify;
        //     }
            
        // }

        ::v-deep .dropdownSelectAnalytics{
            .dropdown-toggle:before{
                top:15px;
                right: 10px;
            }
        }
        
    }

    ::v-deep .mx-input{
            height: 47px;
            border-radius: 25px;
            border-color: #ced4da !important;
            box-shadow: none !important;
    }

    ::v-deep  .custom-select{
        font-size: 14px;
        color: #757575 !important
    }

    ::v-deep .mx-icon-calendar, .mx-icon-clear {
        right: 15px;
    }

    .articles-list_pagination{
        margin:5px;
    }

    .elemHeaderTab{
        display: grid;
        margin-bottom: 15px;
        grid-template-columns: 1fr auto;
        align-items: baseline;
        column-gap: 5px;        
    }

    .textResultSearch{
        max-width: 220px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-weight: 600;
        color:#1937a0;
    }

    .card-dashboard{
        border-radius: 20px;

        .card-header{
            border-top-left-radius:20px;
            border-top-right-radius:20px;

        }
    }

    // /deep/ .custom-checkbox .custom-control-label::before {
    //     border-radius: 1rem;
    // }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
        opacity: 0;
    }

    $break-small: 420px;
    $break-large: 1200px;

    .titleCell{
        color:#686868;
        margin-bottom: 5px;

        @media screen and (max-width: $break-small) {
            
            padding-right: 0 !important;
            //padding-left: 10px !important;
        }

    }

    .filter {
        display: flex;
        justify-content: end;
        @media (max-width: 700px) {
            justify-content: center;
        }
    }
    .painel-content {
        background-color: #FFF;
        margin-top: 30px;
        display: flex;
        
        width: 100%;
        @media (max-width: 700px) {
            border: 1px solid #e6e6e6;
            flex-direction: column;
        }
    } 

    .first-col {
        border-right: 1px solid #ccc; 
        min-height: 500px;
        width: 100%;
        display: flex;
        align-items: center;
        @media (max-width: 700px) {
            border-right: none; 
            min-height: 100px;
            padding-top: 10px;
            margin-bottom: 30px;
        }
    }

  

    
    
</style>
